<template>
    <!-- Page header -->
    <div>
        <div class="page-header page-header-light">
            <div class="page-header-content header-elements-md-inline">
                <div class="page-title d-flex">
                    <h4><span class="font-weight-semibold">Event summary</span></h4>
                    This view presents an aggregates snapshot of the messages received in the deferred/bounce/spam events. Click on the short response to see more detailed view.
                </div>
            </div>
        </div>
        <!-- /page header -->
        <!-- Content area -->
        <div class="content">
            <div class="card">
                <div class="table-responsive" :class="{'loading-mask': loading}">
                    <button @click="load" class="btn btn-primary pull-right" style="margin: 10px">Refresh list</button>
                      <div style="float:left; margin-top: 10px">
                                <router-link :to="{name:'event_summary'}" class="btn btn-primary pull-left" style="margin: 10px">Go back</router-link>
                                <button @click="modifyDay(-1)" class="btn btn-primary pull-left" style="margin: 10px">Previous day</button>
                                <datetime type="date" :input-class="'form-control'" :placeholder="'Choose `from` date'" style="margin-left: 20px; float:left; width:200px" v-model="from"></datetime>
                                <button @click="modifyDay(1)" class="btn btn-primary pull-right" style="margin: 10px">Next day</button>
                            </div>
                            <table class="table table-striped table-xs" style="min-height: 100px">
                                <thead>
                                    <tr>
                                        <th>No.</th>
                                        <th>Sendgrid account</th>
                                        <th>IP</th>
                                        <th>Response short</th>
                                        <th>Count</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="r,k in rows">
                                        <td style="width:10px">{{k+1}}</td>
                                        <td>{{r.account.name}}</td>
                                        <td>{{r.account.use_ip || 'n/a'}}</td>
                                        <td><router-link :to="{name:'event_summary_response', params: {domain: $route.params.domain, day: (new Date(from)).getTime(), event: $route.params.event}, query:{response_short: r._id}}">{{r._id}}</router-link></td>
                                        <td>{{r.count}}</td>
                                        <td>
                                        </td>
                                    </tr>
                                    <h2 v-if="rows.length === 0"> </h2>
                                </tbody>
                            </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
let queryDebounce
import moment from 'moment'
import EventBus from '@/event_bus'
export default {
    data() {
        return {
            showUpload: false,

            from: moment(new Date(this.$route.params.day)).toISOString(),

            rows: [],
            loading: true,
            adding: false,
            limit: 25,
            offset: 0,
            count: 0,
            query: null
        }
    },
    watch: {
        from(){
            this.load()
        }
    },
    computed: {
        pages() {
            if (this.count <= this.limit) {
                return 1
            }

            return Math.ceil(this.count / this.limit)
        },
        page() {
            if (this.offset === 0) {
                return 1
            }
            return (this.offset / this.limit) + 1 || 1
        },
    },
    methods: {
        modifyDay(d){
            this.from = moment(this.from).add(d, 'day').toISOString()
        },
        prevPage() {
            this.offset -= 25
            this.load()
        },
        nextPage() {
            this.offset += 25
            this.load()

        },
        load() {
            this.loading = true
            this.$api.getReq(`event_summary/`+moment(this.from).toDate().getTime()+`/`+this.$route.params.domain+`/`+this.$route.params.event).then(res => {
                this.rows = res.body.data
                this.count = res.body.data.length
                this.loading = false
            })
        }
    },
    destroyed() {},
    mounted() {
        this.load()
    }
}
</script>
<style>
.avsquare {
    width: 7px;
    height: 100%;
    float: left;
    cursor: pointer;
    border-left: 1px solid rgba(0, 0, 0, .1);
}

.avsquare:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.avsquare:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

tbody .btn {
    padding: 3px 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/EventSummaryDomain.vue